import React, { Component } from "react";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  Card,
  Button,
  Table,
  Tooltip,
  BackTop,
  Modal,
  Input,
  message,
} from "antd";
import {
  req_page_tqa_reviewOpinion,
  req_edit_tqa_reviewOpinion,
} from "../../api";

import {
  PAGE_SIZE,
  SORT_FIELD_NAME,
  SORT_UP_DOWN,
} from "../../utils/contrains";
import { usrRole } from "../../utils/dataUtil";

import WorkerModifyModal from "./manage-worker-modify-modal";
import ReviewSchoolOpinionAddModal from "./review-school-opinion-add-modal";

const { TextArea } = Input;

class ReviewSchoolOpinionModal extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  static propTypes = {
    worker: PropTypes.object.isRequired,
  };
  state = {
    deviceWidth: 0,
    loading: false,
    userLevel: "NORMAL",
    items: [],
    item: {},
    pagination: {
      current: 1,
      pageSize: PAGE_SIZE,
      total: 0,
    },
    columnSort: SORT_FIELD_NAME,
    orderBy: SORT_UP_DOWN,
    searchField: "NONE",
    searchValue: "",
    filterStatus: "",

    domnloadFile: "",
    isShowModal: false,
    isEditModal: false,
    isAddModal: false,
    logs: [],
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  componentDidMount() {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    this.api_page_items(1);
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_page_items = (current) => {
    this.current = current; // 保存當前頁，給其他方法可看到
    const { pageSize } = this.state.pagination;
    const { searchField, searchValue, columnSort, orderBy, filterStatus } =
      this.state;
    const { token, userCode, role } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });
    const { WorkManualVersion } = this.props.worker;
    this.api_page_run(
      userCode,
      userLevel,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      WorkManualVersion,
      token
    );
  };

  api_page_run = async (
    userCode,
    userLevel,
    current,
    pageSize,
    columnSort,
    orderBy,
    searchField,
    searchValue,
    filterStatus,
    workManualVersion,
    token
  ) => {
    this.setState({ loading: true });
    const result = await req_page_tqa_reviewOpinion(
      userCode,
      userLevel,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      workManualVersion,
      token
    );
    //console.log(result);
    if (result.total > 0) {
      const { total } = result;
      const items = result.data;
      const pagination = {
        current: this.current,
        pageSize: this.state.pagination.pageSize,
        total,
      };
      this.setState({ items, pagination });
    } else {
      const items = [];
      const pagination = {
        current: 1,
        pageSize: this.state.pagination.pageSize,
        total: 0,
      };
      this.setState({ items, pagination });
    }
    this.setState({ loading: false });
  };

  api_modify_item = async (item) => {
    const { token } = this.props.user;
    const result = await req_edit_tqa_reviewOpinion(item, token);
    if (result.status === "success") {
      message.success(result.message);
    } else {
      message.error(result.message);
    }
  };

  // 數據配置設定 //////////////////////////////////////////////

  init_columns = () => {
    this.columns = [
      {
        title: "頁次",
        width: 30,
        render: (item) => {
          const { TagCode, RecordStatus } = item;
          return (
            <>
              {RecordStatus === "SUBMIT" ? (
                <>{TagCode}</>
              ) : (
                <>
                  <TextArea
                    rows={2}
                    id="TagCode"
                    placeholder="頁數"
                    defaultValue={TagCode}
                    allowClear
                    onChange={(e) => this.onChangeTextArea(e, item)}
                  />
                </>
              )}
            </>
          );
        },
      },
      {
        title: "意見",
        width: 50,
        render: (item) => {
          const { ContentDescription, RecordStatus } = item;
          return (
            <>
              {RecordStatus === "SUBMIT" ? (
                <>{ContentDescription}</>
              ) : (
                <>
                  <TextArea
                    rows={2}
                    id="ContentDescription"
                    placeholder="最少5個字"
                    defaultValue={ContentDescription}
                    allowClear
                    onChange={(e) => this.onChangeTextArea(e, item)}
                  />
                </>
              )}
            </>
          );
        },
      },
      {
        title: "",
        width: 25,
        fixed: "right",
        render: (item) => {
          const { RecordStatus } = item;
          return (
            <>
              {RecordStatus === "DONE" ? (
                <></>
              ) : (
                <>
                  <button
                    className="btn btn-outline-dark btn-sm"
                    style={{ width: "82px" }}
                    onClick={() => this.handle_show_ui_modal("edit", item)}
                    disabled={RecordStatus === "SUBMIT"}
                  >
                    <i className="fa fa-check"></i> 儲存
                  </button>
                  <button
                    className="btn btn-outline-dark btn-sm"
                    style={{ width: "82px" }}
                    onClick={() => this.handle_show_ui_modal("delete", item)}
                    disabled={RecordStatus === "SUBMIT"}
                  >
                    <i className="fa fa-minus"></i> 刪除
                  </button>
                </>
              )}
            </>
          );
        },
      },
    ];
  };

  style_switch_text_tag(column) {
    let ans = "其他";
    switch (column) {
      case "A":
        ans = "學院"; // 學院
        break;
      case "B": // 碩班
        ans = "碩班";
        break;
      case "C":
        ans = "學系"; // 中心
        break;
      case "D":
        ans = "中心"; // 學系
        break;
      default:
        // OTHER
        break;
    }
    return ans;
  }

  style_switch_color_tag(column) {
    let ans = "其他";
    switch (column) {
      case "A":
        ans = "#87d068"; // 學院
        break;
      case "B": // 碩班
        ans = "#108ee9";
        break;
      case "D":
        ans = "#f50"; // 中心
        break;
      case "C": // 學系
        ans = "magenta";
        break;
      default:
        ans = "gold";
        break;
    }
    return ans;
  }

  style_switch_schedule_text(column) {
    let ans = "其他";
    switch (column) {
      case "INIT":
        ans = "初始化"; // 初始化
        break;
      case "EDIT":
        ans = "規劃中"; //
        break;
      case "REVIEW": //
        ans = "送審中";
        break;
      case "DONE":
        ans = "已完成"; //
        break;
      case "E": //
        ans = "院長簽核";
        break;
      case "F":
        ans = "C01-08"; //
        break;
      case "G":
        ans = "C09-15"; //
        break;
      case "H": //
        ans = "C16";
        break;
      case "I":
        ans = "系主任簽核"; //
        break;
      case "J":
        ans = "C09-15"; //
        break;
      case "K":
        ans = "C16"; //
        break;
      case "M":
        ans = "系主任簽核"; //
        break;
      case "N":
        ans = "院內互評"; //
        break;
      case "O":
        ans = "委員評核"; //
        break;
      case "P":
        ans = "評核回應"; //
        break;
      default:
        // OTHER
        break;
    }
    return ans;
  }

  style_switch_schedule_color(column) {
    let ans = "其他";
    switch (column) {
      case "DONE":
        ans = "#87d068";
        break;
      case "INIT":
        ans = "#108ee9";
        break;
      case "REVIEW":
        ans = "#f50";
        break;
      case "C":
        ans = "magenta";
        break;
      default:
        ans = "gold";
        break;
    }
    return ans;
  }

  // 操作互動處理 //////////////////////////////////////////////

  resize() {
    this.setState({ deviceWidth: window.innerWidth });
  }

  handle_page_size_change = (current, size) => {
    //console.log(size)
    this.setState(
      {
        pagination: {
          current: current,
          pageSize: size,
        },
      },
      () => {
        this.api_page_items(current);
      }
    );
  };

  handle_table_change = (pagination, filters, sorter, extra) => {
    if (filters) {
      const status = [...Object.values(filters).filter(Boolean)][0];
      if (status) {
        this.setState({ filterStatus: status }, () => {
          this.api_page_items(pagination.current);
        });
      } else {
        this.setState({ filterStatus: "" }, () => {
          this.api_page_items(pagination.current);
        });
      }
    } else {
      this.api_page_items(pagination.current);
    }
  };

  handle_data_refresh = () => {
    this.api_page_items(this.current);
  };

  handle_show_ui_modal = (modal, item) => {
    switch (modal) {
      case "view":
        this.setState({ isShowModal: true, item });
        break;
      case "edit":
        item.condition = "BASE";
        this.api_modify_item(item);
        //console.log(item);
        break;
      case "add":
        this.setState({ isAddModal: true, item });
        break;
      case "download":
        this.api_downloadfile_items();
        break;
      default:
    }
  };

  handle_ui_field_change = (target_key, target_field, e) => {
    const value = e.target.value;
    const item = {
      activityNid: target_key,
      setPoints: value,
      condition: target_field,
    };
    //console.log(target_key)
    this.api_modify_item(item);
  };

  onChangeTextArea = (e, obj) => {
    const { items } = this.state;

    items.filter(function (item) {
      if (item.WorkManualVersion === obj.WorkManualVersion) {
        Object.keys(item).forEach((propertyName) => {
          if (e.target.id === propertyName && e.target.value !== null) {
            item[propertyName] = e.target.value.trim();
          }
        });
      }
      return item;
    });

    this.setState({ items });
  };

  /////////////////////////////////////////////////////////////

  render() {
    const { loading, item, items, pagination, isEditModal, isAddModal } =
      this.state;

    const title = (
      <>
        <Button
          type="primary"
          onClick={() => this.handle_show_ui_modal("add", this.props.worker)}
        >
          <i className="fa fa-plus"></i>
          <span style={{ marginLeft: "4px" }}>新增</span>
        </Button>{" "}
        <Tooltip placement="top" title="重新整理">
          <Button
            type="primary"
            onClick={() => this.handle_data_refresh()}
            style={{ marginLeft: "4px" }}
          >
            <i className="fas fa-sync-alt"></i>
          </Button>
        </Tooltip>
      </>
    );
    return (
      <Card title={title}>
        <Table
          bordered
          scroll={{ y: 480 }}
          loading={loading}
          rowKey="Id"
          dataSource={items}
          onChange={this.handle_table_change}
          pagination={{
            ...pagination,
            responsive: true,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: [5, 10, 20, 50, 100],
            onShowSizeChange: this.handle_page_size_change,
          }}
          columns={this.columns}
        />
        <Modal
          destroyOnClose={true}
          visible={isEditModal}
          width={"80%"}
          onOk={() => {
            this.setState({ isEditModal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isEditModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <WorkerModifyModal worker={item} />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isAddModal}
          width={"400px"}
          onOk={() => {
            this.setState({ isAddModal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isAddModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <ReviewSchoolOpinionAddModal worker={item} />
        </Modal>

        <BackTop visibilityHeight="80" />
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(ReviewSchoolOpinionModal);
